import React, { useState, useEffect } from "react";
import ReactDropdown from "react-dropdown";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import userApi from "service/userApi";
import { pushNotification } from "utils/notifications";
import ThuocTinhGiamTruApi from "service/ThuocTinhGiamTruApi";

const monthOptions = [
  { value: 0, label: "Tất cả" },
  ...Array.from({ length: 12 }, (_, i) => ({
    value: i + 1,
    label: `Tháng ${i + 1}`,
  })),
];
const currentYear = new Date().getFullYear();
const yearOptions = [
  { value: 0, label: "Tất cả" },
  ...Array.from({ length: currentYear - 2010 + 1 }, (_, i) => ({
    value: currentYear - i,
    label: `${currentYear - i}`,
  })),
];

const loanTypeOptions = [
  { value: 0, label: "Tất Cả" },
  { value: 3, label: "Cầm đồ" },
  { value: 1, label: "Tín Chấp" },
  { value: 2, label: "Trả góp" },
];

export const SearchBarDestop = ({
  initialFilters,
  onApply,
  showPenalty,
  isCauHinhT77,
}) => {
  console.log("[ThongKeThu SearchBarDestop isCauHinhT77]", isCauHinhT77);
  const [filters, setFilters] = useState(initialFilters);
  const [employeeList, setEmployeeList] = useState([]);
  const [listCauHinhTaiSan, setlistCauHinhTaiSan] = useState([]);
  useEffect(() => {
    userApi
      .combo2()
      .then((res) => {
        if (res.status === 200) {
          const allEmployeesOption = { value: "", label: "Tất cả" };
          setEmployeeList([allEmployeesOption, ...res.data]);
        }
      })
      .catch(() => {
        pushNotification("Lỗi không thể tải danh sách nhân viên!", "error");
      });
    loadDanhSachCauHinhTaiSan();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleDateChange = (field) => (date) => {
    setFilters((prev) => ({
      ...prev,
      [field]: date,
      month: 0,
      year: 0,
    }));
  };

  const handleDropdownChange = (field) => (selectedOption) => {
    const value = selectedOption.value;
    setFilters((prev) => {
      const newFilters = { ...prev, [field]: value };
      if (field === "month" && value > 0) {
        const newMonthIndex = value - 1;
        const targetYear = prev.year;
        if (newFilters.dtFrom) {
          if (
            newFilters.dtFrom.getMonth() !== newMonthIndex ||
            (targetYear > 0 && newFilters.dtFrom.getFullYear() !== targetYear)
          ) {
            newFilters.dtFrom = null;
          }
        }
        if (newFilters.dtTo) {
          if (
            newFilters.dtTo.getMonth() !== newMonthIndex ||
            (targetYear > 0 && newFilters.dtTo.getFullYear() !== targetYear)
          ) {
            newFilters.dtTo = null;
          }
        }
      }
      if (field === "year" && value > 0) {
        const newYear = value;

        if (newFilters.dtFrom && newFilters.dtFrom.getFullYear() !== newYear) {
          newFilters.dtFrom = null;
        }
        if (newFilters.dtTo && newFilters.dtTo.getFullYear() !== newYear) {
          newFilters.dtTo = null;
        }
      }
      return newFilters;
    });
  };

  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    if (e) e.preventDefault();
    if (filters.month > 0 && filters.year === 0) {
      pushNotification("Vui lòng chọn năm khi lọc theo tháng!", "error");
      return;
    }
    onApply({ ...filters });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSubmit(event);
    }
  };
  let minDateFromSelection = null;
  let maxDateFromSelection = null;
  if (filters.year > 0) {
    if (filters.month > 0) {
      minDateFromSelection = new Date(filters.year, filters.month - 1, 1);
      maxDateFromSelection = new Date(filters.year, filters.month, 0);
    } else {
      minDateFromSelection = new Date(filters.year, 0, 1);
      maxDateFromSelection = new Date(filters.year, 11, 31);
    }
  }
  const finalMinDateForFromPicker = minDateFromSelection;
  let finalMaxDateForFromPicker = filters.dtTo;
  if (maxDateFromSelection && filters.dtTo) {
    finalMaxDateForFromPicker =
      maxDateFromSelection < filters.dtTo ? maxDateFromSelection : filters.dtTo;
  } else if (maxDateFromSelection) {
    finalMaxDateForFromPicker = maxDateFromSelection;
  }
  const loadDanhSachCauHinhTaiSan = async () => {
    try {
      const res = await ThuocTinhGiamTruApi.danhsachcauhinhtaisan();
      const list = res.data.List || [];
      setlistCauHinhTaiSan(list);
      return list;
    } catch (error) {
      console.error("Lỗi load danh sách cấu hình tài sản:", error);
      setlistCauHinhTaiSan([]);
      return [];
    }
  };

  const finalMaxDateForToPicker = maxDateFromSelection;
  let finalMinDateForToPicker = filters.dtFrom;
  if (minDateFromSelection && filters.dtFrom) {
    finalMinDateForToPicker =
      minDateFromSelection > filters.dtFrom
        ? minDateFromSelection
        : filters.dtFrom;
  } else if (minDateFromSelection) {
    finalMinDateForToPicker = minDateFromSelection;
  }
  return (
    <form onSubmit={handleSubmit} onKeyDown={handleKeyDown}>
      <div className="search-new d-flex flex-row align-items-end justify-content-start gap-3 flex-wrap">
        <div className="input-sm-new" style={{ flex: 1, minWidth: "120px" }}>
          <label className="font-color-default font-bold">Tên KH, Mã HĐ</label>
          <input
            type="text"
            name="keywordHopDong"
            placeholder="Nhập từ khóa..."
            value={filters.keywordHopDong}
            onChange={handleChange}
            className="form-control input-sm"
          />
        </div>
        <div className="input-sm-new" style={{ flex: 1, minWidth: "120px" }}>
          <label className="font-color-default font-bold">Mã Ngoài Lề</label>
          <input
            type="text"
            name="keywordNgoaiLe"
            placeholder="Nhập từ khóa..."
            value={filters.keywordNgoaiLe}
            onChange={handleChange}
            className="form-control input-sm"
          />
        </div>
        <div className="input-sm-new" style={{ flex: 1, minWidth: "120px" }}>
          <label className="font-color-default font-bold">Từ ngày</label>
          <DateTimePicker
            value={filters.dtFrom}
            onChange={handleDateChange("dtFrom")}
            placeholder="Chọn ngày"
            minDate={finalMinDateForFromPicker}
            maxDate={finalMaxDateForFromPicker}
          />{" "}
        </div>
        <div className="input-sm-new" style={{ flex: 1, minWidth: "120px" }}>
          <label className="font-color-default font-bold">Đến ngày</label>
          <DateTimePicker
            value={filters.dtTo}
            onChange={handleDateChange("dtTo")}
            placeholder="Chọn ngày"
            minDate={finalMinDateForToPicker}
            maxDate={finalMaxDateForToPicker}
          />
        </div>
        <div className="input-sm-new" style={{ minWidth: "100px" }}>
          <label className="font-color-default font-bold">Tháng</label>
          <ReactDropdown
            options={monthOptions}
            onChange={handleDropdownChange("month")}
            value={monthOptions.find(
              (option) => option.value === filters.month,
            )}
            placeholder="Chọn tháng"
            controlClassName="form-control input-sm"
          />
        </div>
        <div className="input-sm-new" style={{ minWidth: "100px" }}>
          <label className="font-color-default font-bold">Năm</label>
          <ReactDropdown
            options={yearOptions}
            onChange={handleDropdownChange("year")}
            value={yearOptions.find((option) => option.value === filters.year)}
            placeholder="Chọn năm"
            controlClassName="form-control input-sm"
          />
        </div>
        {isCauHinhT77 && (
          <>
            <div className="input-sm-new" style={{ minWidth: "100px" }}>
              <label className="font-color-default font-bold">Loại vay</label>
              <select
                id="LoaiVay"
                name="LoaiVay"
                value={filters.LoaiVay}
                onChange={handleSelectChange}
                className="form-control input-sm"
              >
                {loanTypeOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="input-sm-new" style={{ minWidth: "100px" }}>
              <label className="font-color-default font-bold">
                Loại tài sản
              </label>
              <select
                id="CauHinhTaiSanId"
                name="CauHinhTaiSanId"
                value={filters.CauHinhTaiSanId}
                onChange={handleSelectChange}
                className="form-control input-sm"
              >
                <option value="">Tất cả</option>
                {listCauHinhTaiSan &&
                  listCauHinhTaiSan.map((cauhinh, index) => (
                    <option key={index} value={cauhinh.CauHinhTaiSanId}>
                      {cauhinh.TenHangHoa}
                    </option>
                  ))}
              </select>
            </div>
          </>
        )}
        {showPenalty && (
          <div
            className="input-sm-new input-new-18"
            style={{ minWidth: "150px" }}
          >
            <label className="font-color-default font-bold">Nhân viên</label>
            <ReactDropdown
              options={employeeList}
              onChange={handleDropdownChange("employee")}
              value={
                employeeList.find(
                  (option) => option.value === filters.employee,
                ) || employeeList[0]
              }
              controlClassName="form-control input-sm"
            />
          </div>
        )}
        <div className="input-sm-new mt-1">
          <button
            type="submit"
            className="btn btn-info-new"
            style={{ paddingTop: "7px" }}
          >
            <i className="la la-search"></i> Tìm kiếm
          </button>
        </div>
      </div>
    </form>
  );
};
